import flooringTypesList from "./flooring-types.list";

export const FlooringTypeStores = {
    list: flooringTypesList,
}